





































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { studentBind } from '@/api/admin'
import XLSX from 'xlsx'
import Excel from './../excel/excel.js'
import { checkStuNumber } from './student.api'

@Component
export default class StudentImport extends ViewBase {
  @Prop({ type: Boolean, default: true }) visible!: boolean

  labelCol = { span: 24 }
  wrapperCol = { span: 24 }
  lang = {}
  isEdit = false
  school = ''
  form = {}
  svisible = false
  loading: boolean = false
  listenChange: boolean = false
  get i18n() {
    const value = this.$t('login')
    return value as any
  }
  get getHeadMapList() {
    return [
      { test1: '测试1', test2: '2312123' },
      { test1: '测试2', test2: '23123' }
    ]
  }

  uploadExcel() {
    const oploadRef: any = document.getElementById('upload')
    if (!this.listenChange) {
      oploadRef.addEventListener('change', (e: any) => {
        // 绑定监听表格导入事件
        this.readExcel(e)
        this.listenChange = true
      })
    }
    oploadRef.click()
  }

  readExcel(e: any) {
    // 表格导入
    const that = this
    const files = e.target.files
    const oploadRef: any = document.getElementById('upload')
    // console.log(files)
    if (files.length <= 0) {
      // 如果没有文件名
      return false
    } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
      this.handleError(this.i18n.vStudentList.fileFormatWrong)
      return false
    }
    this.$emit('showLoading', true)
    const fileReader = new FileReader()
    fileReader.onload = (ev: any) => {
      this.loading = true
      try {
        const data = ev.target.result
        const workbook = XLSX.read(data, {
          type: 'binary'
        })
        // 取第一张表
        const wsname = workbook.SheetNames[0]
        // 生成json表格内容
        const ws: any = XLSX.utils.sheet_to_json(workbook.Sheets[wsname])
        // console.log(ws)
        // 清空接收数据
        const outputs = []
        // 编辑数据
        const nameStr = this.i18n.vStudentList.stuName
        const numberStr = this.i18n.vStudentList.stuNumber
        const tableWrong = this.i18n.vStudentList.tableWrong
        for (const item of ws) {
          if (!item[nameStr] || !item[numberStr]) {
            this.handleError(tableWrong)
            this.$emit('showLoading', false)
            return
          }
          const sheetData = {
            stu_name: item[nameStr],
            stu_number: item[numberStr]
          }
          outputs.push(sheetData)
        }
        this.checkStu(outputs)
        oploadRef.value = ''
      } catch (e) {
        return false
      }
    }
    fileReader.readAsBinaryString(files[0])
  }
  async checkStu(outputs: any) {
    const data: any = {
      studentData: outputs
    }
    try {
      const res = await checkStuNumber(data)
      this.$emit('showLoading', false)
      this.$emit('loadedExcel', res.data)
    } catch (ex) {
      this.$emit('showLoading', false)
      this.handleError(ex)
    }
  }
  created() {
    this.school = JSON.parse(localStorage.school).school_key
    this.lang = this.i18n.vBinding
    this.form = this.$form.createForm(this)
    const lang: any = this.lang
  }
  @Watch('visible')
  watchVisible(visible: any) {
    this.svisible = visible
    if (!visible) {
      this.listenChange = false
    }
  }

  exportToExcel() {
    const fields: any = {
      test1: this.i18n.vStudentList.stuName,
      test2: this.i18n.vStudentList.stuNumber
    }
    this.getHeadMapList.forEach((item: any) => {
      fields['_' + item.key] = item.value // 动态生成的头
    })
    // fields.totalCommission = '奖励总数'
    // 此处有vue大坑，不能直接使用xlsx(this.getComputedData),必须先转一下
    const data = JSON.parse(JSON.stringify(this.getHeadMapList))
    const excel: any = Excel
    excel(data, fields, this.i18n.vStudentList.downExample)
  }
  onCancel() {
    const form: any = this.form
    form.resetFields()
    this.$emit('onCancel')
  }
  loadExcel(e: any) {}
  async onOk(pdata: any) {
    try {
      const res = await studentBind(pdata)
      this.$message.success(this.i18n.vAccountForm.operationSuccess)
      const form: any = this.form
      form.resetFields()
      this.$emit('onOk')
    } catch (ex) {
      this.handleError(ex)
    }
  }
}
